export enum AttendancecurrentAction {
  CheckIn,
  CheckOut,
  DisabledCheckOut,
}
